// extracted by mini-css-extract-plugin
export default {"disconnect_container":"S2_Disconnected_disconnect_container__IvhMB","disconnect_text":"S2_Disconnected_disconnect_text__m313V"};